module.exports = __webpack_public_path__ + "img/og_ravenol.63578b2f.jpg";